/** Port von `IwmSharedColumnsDecimal.razor`. */

import { formatNumber, type NumberFormat } from '@/utils/number';

export interface DecimalCellProps {
  value: number | null | undefined;
  format?: NumberFormat;
  suffix?: string;
}

export function DecimalCell(props: DecimalCellProps) {
  if (props.value === null || props.value === undefined) return null;
  return (
    <span style={{ float: 'right' }}>
      {formatNumber(props.value, props.format ?? 'N2')}
      {props.suffix ?? ''}
    </span>
  );
}

export default DecimalCell;
